import { render, staticRenderFns } from "./AccountSettingProposalsAgency.vue?vue&type=template&id=9ca87324&"
import script from "./AccountSettingProposalsAgency.vue?vue&type=script&lang=js&"
export * from "./AccountSettingProposalsAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports